import styled from "@emotion/styled";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { SecondaryButtonProps } from "@unlikelyai-magic/ui/buttons";
import { Icon } from "@unlikelyai-magic/ui/icons";
import { SecondaryButton } from "./SecondaryButton";

const StyledButton = styled(SecondaryButton)`
  padding: 0.75rem 1.5rem;
`;

export const NewQuestionButton = ({ ...props }: SecondaryButtonProps) => {
  return (
    <StyledButton {...props}>
      <Icon icon={ArrowPathIcon} />
      Ask another question
    </StyledButton>
  );
};
